import { Alert, Button, Card, Empty, Radio, Table, Tag } from "@arco-design/web-react";
import type { ColumnProps } from "@arco-design/web-react/es/Table";

import { useFinancePaymentRequestListRuntime } from "../runtime/useFinancePaymentRequestListRuntime";
import {
  FINANCE_PAYMENT_REQUEST_LIST_SCOPE_OPTIONS,
  financePaymentRequestPaidLabel,
  financePaymentRequestStatusLabel,
  financePaymentTypeLabel,
  formatFinancePaymentRequestAmount,
  formatFinancePaymentRequestApprovers,
  formatFinancePaymentRequestTime,
} from "../service/financePaymentRequestService";
import type { FinancePaymentRequestItem, FinancePaymentRequestListScope } from "../types";
import "./financePaymentRequest.css";

type Props = {
  onOpenRequest: (requestId: string) => void;
};

/** 请款记录：一张简单清单，能看的人看全部请款，按提交时间倒序；可切待付款、我发起的；点「查看」打开详情。 */
export function FinancePaymentRequestListFeaturePage({ onOpenRequest }: Props) {
  const runtime = useFinancePaymentRequestListRuntime();
  const columns: ColumnProps<FinancePaymentRequestItem>[] = [
    { title: "请款单号", dataIndex: "requestNo", width: 150 },
    { title: "团", dataIndex: "itineraryTitle" },
    { title: "结算主体", dataIndex: "settlementSupplierName" },
    { title: "款项类型", width: 100, render: (_, row) => financePaymentTypeLabel(row.paymentType) },
    {
      title: "金额",
      width: 140,
      align: "right",
      render: (_, row) => <span className="finance-payment-request-money">{formatFinancePaymentRequestAmount(row.amount)}</span>,
    },
    { title: "状态", width: 90, render: (_, row) => <Tag>{financePaymentRequestStatusLabel(row.status)}</Tag> },
    { title: "当前审批人", width: 140, render: (_, row) => formatFinancePaymentRequestApprovers(row.currentApprovers) },
    { title: "是否已付", width: 90, render: (_, row) => financePaymentRequestPaidLabel(row.status) },
    { title: "申请人", dataIndex: "applicantName", width: 100 },
    { title: "提交时间", width: 170, render: (_, row) => formatFinancePaymentRequestTime(row.submittedAt) },
    {
      title: "操作",
      width: 80,
      render: (_, row) => (
        <Button type="text" onClick={() => onOpenRequest(row.requestId)}>查看</Button>
      ),
    },
  ];
  return (
    <main className="finance-payment-request-page">
      <Card className="finance-payment-request-card">
        <Radio.Group
          type="button"
          className="finance-payment-request-scope"
          options={FINANCE_PAYMENT_REQUEST_LIST_SCOPE_OPTIONS}
          value={runtime.scope}
          onChange={(value: FinancePaymentRequestListScope) => runtime.setScope(value)}
        />
        {runtime.error ? (
          <Alert
            type="error"
            content="请款记录加载失败，请重试。"
            action={<Button size="mini" onClick={runtime.refresh}>重试</Button>}
          />
        ) : null}
        <Table<FinancePaymentRequestItem>
          rowKey="requestId"
          loading={runtime.loading}
          columns={columns}
          data={runtime.items}
          scroll={{ x: 1290 }}
          noDataElement={<Empty description="还没有请款" />}
          pagination={{ current: runtime.page, pageSize: runtime.pageSize, total: runtime.total, onChange: runtime.setPage }}
        />
      </Card>
    </main>
  );
}
